module.exports = {
  btn: {
    btn1: '确定',
    btn2: '取消',
    btn3: '支取',
    btn4: '完成',
    btn5: '示例',
    btn6: '试算',
    btn7: '返回',
    btn8: '立即支取',
    btn9: '我知道了',
    btn10: '全部支取并解约'
  },
  label: {
    label0: '智能存款 火爆发售',
    label1: '活期的便利 定期的收益',
    label2: '存入',
    label3: '不在服务时间。',
    label4: '交易时间为每日0:00-21:00。',
    label5: '零钱轻松筹',
    label6: '半年/一年娱乐计划',
    label7: '为亲爱的Ta准备一份圣诞/生日惊喜',
    label8: '存工资轻松无忧',
    label9: '请先登录。',
    label10: '零钱储一储 都是一大笔',
    label11: '余额自动转入 让您轻松享收益',
    label12: '定期派息',
    label13: '当日计息',
    label14: '省心省力',
    label15: '新增计划',
    label16: '年度娱乐 尽早筹划',
    label17: '准备一趟甜美的旅行',
    label18: '',
    label19: '新款的包包真系靓',
    label20: '',
    label21: '为学习爱好积攒资金',
    label22: '',
    label23: '每月自动攒 财富一定赞',
    label24: '工资到账',
    label25: '自动存入',
    label26: '收益buff',
    label27: '主动加薪',
    label28: '圣诞/生日在即 礼物要急',
    label29: '离圣诞只有100天 来不及准备礼物资金啊',
    label30: '不要急 智能存款会帮您',
    label31: '月供存款',
    label32: '活期存款',
    label33: '月月高存款',
    label34: '天天利存款',
    label35: '定期存款',
    label36: '月月储钱月月多',
    label37: '零钱钱包储不停',
    label38: '按月靠档利率高',
    label39: '按天靠档利率高',
    label40: '定期储钱最放心',
    label41: '我的',
    label42: '2万以下',
    label43: '2万（含2万）~100万',
    label44: '100万以上（含100万）',
    label45: '0-10万',
    label46: '10-20万',
    label47: '20-50万',
    label48: '50万以上（含50万）',
    label49: '20-100万',
    label50: '10-50万',
    label51: '存期',
    label52: '存入',
    label53: '交易记录',
    label54: '总持仓',
    label55: '累计收益：',
    label56: '共',
    label57: '种存款',
    label58: '购买金额',
    label59: '预计到期可得金额',
    label60: '存期',
    label61: ' 已存入',
    label62: '天 ',
    label63: '到期',
    label64: '预计到期金额',
    label65: '期限',
    label66: '利率',
    label67: '购买币种',
    label68: '购买账户',
    label69: '到期存入账户',
    label70: '存款期限',
    label71: '存款利率',
    label72: '个月',
    label73: '交易记录',
    label74: '温馨提示：月月高存款产品提前支取只支持提前全部支取。',
    label75: '温馨提示：活期产品提前支取可部分或全部支取。',
    label76: '若需终止此产品需进行解除签约。',
    label77: '提前支取',
    label78: '解除签约',
    label79: '温馨提示：定期存款产品提前支取只支持提前全部支取。',
    label80: '温馨提示：天天利存款产品提前支取只支持提前全部支取。',
    label81: '温馨提示：月供存款产品提前支取只支持提前全部支取。',
    label82: '筛选',
    label83: '重置',
    label84: '交易对象',
    label85: '全部对象',
    label86: '活期',
    label87: '定期',
    label88: '天天利',
    label89: '月供',
    label90: '月月高',
    label91: '交易类型',
    label92: '购买',
    label93: '全部交易',
    label94: '赎回',
    label95: '结息',
    label96: '供款',
    label97: '利息转存',
    label98: '存入币种',
    label99: '存入期限',
    label100: '购买账户',
    label101: '存入金额',
    label102: '起购金额{0}起',
    label103: '请选择购买账户',
    label104: '全部存入',
    label105: '账户当前可用余额',
    label106: '我已阅读',
    label107: '留存金额',
    label108: '签约账户',
    label109: '派息频率',
    label110: '供款金额',
    label111: '供款账户',
    label112: '信息确认',
    label113: '交易失败，请检查',
    label114: '存入成功',
    label115: '申请已提交',
    label116: '当日计息',
    label117: '到期',
    label118: '支取失败，请检查',
    label119: '支取成功',
    label120: '本金',
    label121: '利息',
    label122: '计息规则',
    label123: '',
    label124: '{0}元起存，存期内按存款月数和存款金额靠档计息，一次性存入本金，支持全部提前支取。',
    label125: '按照存入当日我行APP产品页面公布的产品利率靠档计付利息；',
    label126: '可全部提前支取，当存够一档月数计付对应的利息，未存够下一档月数无利息。',
    label127: '收益计算器',
    label128: '请选择币种',
    label129: '请选择存期',
    label130: '拖动滑条选择您要存入的金额',
    label131: '预计到期可获取收益',
    label132: '开启您的存款计划',
    label133: '买入',
    label134: '到期日',
    label135: '如客户存入MOP10万，3+2+1个月。到期支取，存期满6个月，利息为MOP10万（{0}/365*3个月实际天数+ {1}/365*2个月实际天数+{2}/365*1个月实际天数）。',
    label136: '活期产品{0}元起存，设定签约活期账户的留存金额，当日终账户余额大于留存金额时，大于部分存入日日赚；当日终账户余额小于留存金额时，小于部分从日日赚返回活期账户。支持全部或部分提取本金及利息。',
    label137: '按照存入当日我行APP产品页面公布的产品利率靠档计付利息。',
    label138: '如客户购买并签约了1万MOP币种日均存款产品。',
    label139: '日均余额0-10万，年利率为{0}%；日均余额10-20万，年利率为{1}%;',
    label140: '日均余额20-50万，年利率为{0}%；日均余额50万及以上，年利率为{1}%。',
    label141: '如客户购买并签约了1万MOP币种定期产品，存期为3个月，最高利率为{0}%',
    label142: '定期产品',
    label143: '{0}元起存，存款时约定存期，一次性存入本金，支持全部提前支取。',
    label144: '按照存入当日我行APP产品页面公布的产品利率靠档计付利息；',
    label145: '可全部提前支取，提前支取部分按支取当日我行提前支取利率计息。',
    label146: '{0}元起存，存期内按存款天数靠档计息，按固定天数派息，一次性存入本金，支持全部提前支取本金和利息。',
    label147: '按照存入当日我行APP产品页面公布的产品利率靠档计付利息；',
    label148: '可全部提前支取，支取金额按存款天数对应的产品利率靠档计息。',
    label149: '派息规则',
    label150: '存期50天，每15天派息一次；',
    label151: '存期100天，每30天派息一次；',
    label152: '存期160天，每50天派息一次。',
    label153: '160天天利存款之利息将分为3个阶段计算，1)第1阶段为开立存款日起计算100日；第2阶段为开立存款日起计第101日至第150日；第3阶段为开立存款日第151日至存款到期日。2)存款利息每50日派息一次',
    label154: '{0}元起存，每月供款金额不少于{1}元，存款时约定存期，每月1号扣款，到期自动返还本金和利息，支持全部提前支取。',
    label155: '按照存入当日我行APP产品页面公布的产品利率计付利息；',
    label156: '可全部提前支取，提前支取无利息。',
    label157: '1.计息每年按360天，每月按30天计算',
    label158: '2.计息每年按360天，每月按30天计算2.按存款金额实际存期计息。开户金额*日利率*实际存入日数+第1期供款金额*日利率*实际存入日数+第2期供款金额*日利率*实际存入日数+……+第12期供款金额*日利率*实际存入日数',
    label159: '最高',
    label160: '澳门币',
    label161: '人民币',
    label162: '港币',
    label163: '美元',
    label164: '加元',
    label165: '英镑',
    label166: '澳元',
    label167: '存款金额',
    label168: '50天',
    label169: '80天',
    label170: '100天',
    label171: '160天',
    label172: '已存入',
    label173: '存款',
    label174: '暂无数据',
    label175: '账户',
    label176: '请选择账单月份',
    label177: '币种',
    label178: '存款期限',
    label179: '请选择存入币种',
    label180: '请选择存入期限',
    label181: '请选择购买账户',
    label182: '金额不能为空',
    label183: '请输入正确的金额',
    label184: '请同意条款',
    label185: '收益账户',
    label186: '支取至',
    label187: '请选择签约账户',
    label188: '预计收益',
    label189: '请选择派息频率',
    label190: '请输入留存金额',
    label191: '支取金额',
    label192: '请输入支取金额',
    label193: '可取出',
    label194: '全部支取',
    label195: '请输入供款金额',
    label196: '请选择供款账户',
    label197: '供款金额不能为空',
    label198: '供款账号不能为空',
    label199: '供款金额不能小于{0}',
    label200: '您没有该币种账户',
    label201: '没有更多数据了……',
    label202: '本金自动转存',
    label203: '本息自动转存',
    label204: '到期转入转出账户',
    label205: '年',
    label206: '个月',
    label207: '天',
    label208: '年',
    label209: '个月',
    label210: '天',
    label211: '您没有该币种账户，将自动为您切换账户',
    label212: '您名下没有账户',
    label213: '，清楚并同意该',
    label214: '《协议条款》',
    label215: '恭喜您完成购买慧月高产品，若有绑定以下服务，您可前往我行任一分行领取价值MOP100面值的文具礼券，先到先得，送完即止。\n' +
      '服务包括：信用卡/信用卡自动还款/银证通/保险/CEM自动缴费/税费自动转账/现金分享自动入账。',
    label216: '我的购买',
    label217: '本次活动利率表',

    label218: '存款周期：',
    label219: '提供币种：',
    label220: '起存金额：',
    label221: '计息规则：按存期靠档计息',
    label222: '利率：',
    label223: '期限',
    label224: '至',
    label225: '{0}天后',
    label226: '到期后安排',
    label227: '年利率：',
    label228: '最大购买金额为',
    label229: ''
  },
  title: {
    title0: '产品分类',
    title1: '智能存款产品',
    title2: '我的',
    title3: '存款信息详情',
    title4: '交易记录',
    title5: '月月高存款',
    title6: '信息录入',
    title7: '交易结果',
    title8: '支取结果',
    title9: '信息确认',
    title10: '活期存款',
    title11: '定期存款',
    title12: '天天利存款',
    title13: '月供存款',
    title14: '{0}支取',
    title15: '{0}解约',
    title16: '',
    title17: '',
    title18: '',
    title19: ''
  },
  argument: {
    // 月月高
    argument1: '1.「3+2+1月月高」存款之利息将分为3个阶段计算：',
    argument2: '2.「5+5+2月月高」存款之利息将分为3个阶段计算：',
    argument3: '3.每阶段期满后提前支取，客户可支取已满阶段的利息及本金；如在未满阶段前提前支取，将不获发未满阶段的存款利息。',
    argument4: '4.上述之计息资料仅供参考，一切账项须以银行入账记录为准。',
    argument5: '5.推广期有限，额满即止。',
    argument6: '6.立桥银行股份有限公司保留所有条款及细则的权利，而无须另行通知。',
    argument7: '7.上述推广受条款及细则约束，如有任何争议，立桥银行保留对上述推广的最终审核、终止与解释之权利。',
    argument8: '8.如本条款及细则的中、英文版本有歧异， 一律以中文版本为准。',
    argument50: '1）第1阶段为开立定期存款日起计算3个月；第2阶段为开立定期存款日起计第4至第5个月；第3阶段为开立定期存款日第6个月至存款到期日。',
    argument51: '2）本金及利息将于6个月期满的到期日入账至客户原扣账账户中。',
    argument52: '1）第1阶段为开立定期存款日起计算首5个月；第2阶段为开立定期存款日起计第6个月至第10个月；第3阶段为开立定期存款日起计第11个至第12个月。',
    argument53: '2）本金及利息将于12个月期满的到期日入账至客户原扣账账户中。',
    argument54: '',
    argument55: '',
    argument56: '',
    argument57: '',
    argument58: '',
    // 天天利
    argument9: '1.「160天天金」存款之利息将分为3个阶段计算，1)第1阶段为开立存款日起计算100日；第2阶段为开立存款日起计第101日至第150日；第3阶段为开立存款日第151日至存款到期日。2)存款利息每50日派息一次。',
    argument10: '2.「100天天金」存款之利息将分为3个阶段计算，1)第1阶段为开立存款日起计算60日；第2阶段为开立存款日起计第61日至第90日；第3阶段为开立存款日第91日至存款到期日。2)存款利息每30日派息一次。',
    argument11: '3.「50天天金」存款之利息将分为3个阶段计算，1)第1阶段为开立存款日起计算30日；第2阶段为开立存款日起计第31日至第45日；第3阶段为开立存款日第46日至存款到期日。2)存款利息每15日派息一次。',
    argument12: '4.利息将按存款余额计算于指定周期派息日完结后的下一日存入客户的指定账户；提前取出本金部份之利息将按实际存款期(按天)计算，有关利息将于提取时同时存入客户原扣账账户。',
    argument13: '5.上述之计息资料仅供参考， 一切账项须以银行记录为准。',
    argument14: '6.客户起存金额为等值澳门币100元，上限为等值澳门币100万元。',
    argument15: '7.推广期有限，额满即止。',
    argument16: '8.立桥银行股份有限公司保留所有条款及细则的权利，而无须另行通知。',
    argument17: '9.上述推广受条款及细则约束，如有任何争议，立桥银行保留对上述推广的最终审核、终止与解释之权利。',
    argument18: '10.如本条款及细则的中、英文版本有歧异， 一律以中文版本为准。',
    // 定期
    argument19: '1.本金及利息将于存款到期日自动存入原扣账户口。',
    argument20: '2.推广期有限，额满即止。',
    argument21: '3.立桥银行股份有限公司保留所有条款及细则的权利，而无须另行通知。',
    argument22: '4.上述推广受条款及细则约束，如有任何争议，立桥银行保留对上述推广的最终审核、终止与解释之权利。',
    argument23: '5.如本条款及细则的中、英文版本有歧异， 一律以中文版本为准。',
    // 活期
    argument24: '1.该产品是一种根据客户约定，将就活期账户扣除约定留存金额后的资金存入智能存款账户，按日均余额靠档计息。',
    argument25: '2.每日日终，如客户绑定的活期账户余额高于客户约定留存金额，将就活期账户扣除约定留存金额后的资金存入智能存款账户；每日日终，如客户绑定的活期账户留存金额低于客户约定留存金额，将就智能存款账户扣除相关金额，补足活期账户的留存金额。',
    argument26: '3.利息于每月存入客户原扣款账户。',
    argument27: '4.如需解约该产品，需办理终止手续。',
    argument28: '5.计息资料仅供参考，一切账项须以银行入账记录为准。 ',
    argument29: '6.推广期有限，额满即止。',
    argument30: '7.立桥银行股份有限公司保留所有条款及细则的权利，而无须另行通知。',
    argument31: '8.上述推广受条款及细则约束，如有任何争议，立桥银行保留对上述推广的最终审核、终止与解释之权利。',
    argument32: '9.如本条款及细则的中、英文版本有歧异， 一律以中文版本为准。',
    // 月供
    argument33: '1.月供存款必须透过本行账户安排自动转账；',
    argument34: '2.签约月供存款产品，不能同时签约高息活期产品；',
    argument35: '3.月供款项将于每月1号在客户指定账户中扣取；',
    argument36: '4.倘若客户逾期供款，将不影响账户正常计息，最终可获利息按照实际存入金额计算；',
    argument37: '5.取消月供存款账户或提前支取月供存款账户内的款项将不获发利息；',
    argument38: '6.年利率及汇率将根据市况变化而不时调整，立桥银行股份有限公司保留随时更改上述利率及汇率优惠之权利；',
    argument39: '7.客户起存金额为存入相应币种的500元，上限为存入相应币种的100万元。',
    argument40: '8.推广期有限，额满即止；',
    argument41: '9.立桥银行股份有限公司保留所有条款及细则的权利，而无须另行通知；',
    argument42: '10.上述推广受条款及细则约束，如有任何争议，立桥银行保留对上述推广的最终审核、终止与解释之权利；',
    argument43: '11.如本条款及细则的中、英文版本有歧异， 一律以中文版本为准。'
  }
}
